import { render, staticRenderFns } from "./poi-slide-audio.vue?vue&type=template&id=428b58a7&"
import script from "./poi-slide-audio.vue?vue&type=script&lang=ts&"
export * from "./poi-slide-audio.vue?vue&type=script&lang=ts&"
import style0 from "./poi-slide-audio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports